module.exports = __webpack_public_path__ + "static/easy_use-c61b250f700509504a2659c988cf3c0c.png";